/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ReadOnlyActivity.vue?vue&type=template&id=1015e516"
import script from "./ReadOnlyActivity.ts?vue&type=script&lang=ts&external"
export * from "./ReadOnlyActivity.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports